import { render, staticRenderFns } from "./MemberGroupsTable.vue?vue&type=template&id=0f6db65c&"
import script from "./MemberGroupsTable.vue?vue&type=script&lang=js&"
export * from "./MemberGroupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports